import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import FactoryContext from "../../contexts/factoryContext";
import useLeague from "../../hooks/queryResults/useLeague";
import useUserInfo from "../../hooks/queryResults/useUserInfo";
import useCurrentUser from "../../hooks/useCurrentUser";
import { getCurrentWeekForUrl } from "../../store/slices/time";
import Dropdown from "../ui/Dropdown";

export default function LeagueLinksDropdown() {
  const factory = useContext(FactoryContext);
  const currentUser = useCurrentUser();
  const currentWeekForUrl = useSelector(getCurrentWeekForUrl);
  const { league: leagueUrl } = useParams();
  const history = useHistory();

  const { userInfo, userInfoQuery } = useUserInfo();
  const { league, leagueQuery } = useLeague();

  let selectedId;
  const leagues = [];
  if (!leagueUrl) {
    leagues.push({ id: 1, value: "No league selected" });
    selectedId = 1;
  } else if (league) {
    leagues.push({ id: league.obj.id, value: league.obj.name });
    selectedId = league.obj.id;
  } else {
    if (leagueQuery.isLoading) return "loading...";
    if (leagueQuery.isError) {
      console.error(leagueQuery.error);
      return null;
    }
  }

  if (currentUser.isLoggedIn) {
    if (userInfo) {
      Object.keys(userInfo.data.leagues).forEach((leagueId) => {
        if (leagueId !== league?.obj?.id)
          leagues.push({
            id: leagueId,
            value: userInfo.data.leagues[leagueId].name,
          });
      });
    } else {
      if (userInfoQuery.isLoading) {
        leagues.push({ id: "loading", value: "loading..." });
      } else if (userInfoQuery.isError) {
        console.error(userInfoQuery.error);
        leagues.push({
          id: "error",
          value: "an error occurred while loading leagues",
        });
      }
    }
  }

  const getLinkPathForItem = (leagueItem) => {
    const leagueId = leagueItem.id;
    if (["loading", "error"].includes(leagueId)) return;

    if (leagueId === 1) return;
    if (!userInfo) return;

    if (!userInfo.data.leagues[leagueId]) {
      console.error(`Could not find league ${leagueId}`);
      return;
    }

    const leagueObj = userInfo.data.leagues[leagueId];
    const league = factory.makeLeague(leagueObj);
    const leagueSeasonObj = league.getRecentLeagueSeasonObj();
    const leagueSeason = factory.makeLeagueSeason(leagueSeasonObj);

    return leagueSeason.getPath({ week: currentWeekForUrl });
  };

  const handleSelectLeague = (leagueItem) => {
    const linkPath = getLinkPathForItem(leagueItem);

    if (linkPath !== window.location.pathname) history.push(linkPath);
  };

  leagues.sort((a, b) => {
    if (a.value === b.value) return 0;
    return a.value < b.value ? -1 : 1;
  });

  if (leagues.length === 1) {
    const linkPath = getLinkPathForItem(leagues[0]);
    return linkPath ? <Link to={linkPath}>{leagues[0].value}</Link> : null;
  }

  return (
    <Dropdown
      items={leagues}
      selectedId={selectedId}
      handleSelectItem={handleSelectLeague}
    />
  );
}
